import angular from 'angular';
import providerInfoToolsDownloads from './providerInfoToolsDownloads';
import providerInfoDownloadables from './providerInfoDownloadables';

export default angular
  .module('components.providerInfoToolsDownloads', [])
  .component('providerInfoToolsDownloads', providerInfoToolsDownloads)
  .component('providerInfoDownloadables', providerInfoDownloadables).name;
